import {CALL_API} from 'redux-api-middleware';
import {
  API_PROFILE_GET_REQUEST,
  API_PROFILE_GET_SUCCESS,
  API_PROFILE_GET_FAILURE,
  API_PROFILE_PUT_REQUEST,
  API_PROFILE_PUT_SUCCESS,
  API_PROFILE_PUT_FAILURE,
  API_PROFILE_PATCH_REQUEST,
  API_PROFILE_PATCH_SUCCESS,
  API_PROFILE_PATCH_FAILURE,
} from 'common/types';
import {ENDPOINT_USER} from 'common/endpoints';
import {commonJwtHeader, commonJwtHeaderNoCT} from 'common/utils';

export default {
  getUser: (userId) => {
    return {
      [CALL_API]: {
        endpoint: ENDPOINT_USER + encodeURIComponent(userId),
        headers: commonJwtHeaderNoCT(),
        method: 'GET',
        types: [
          API_PROFILE_GET_REQUEST,
          API_PROFILE_GET_SUCCESS,
          API_PROFILE_GET_FAILURE,
        ],
      },
    };
  },
  putUser: (userId, payload, token) => {
    return {
      [CALL_API]: {
        endpoint: ENDPOINT_USER + encodeURIComponent(userId),
        headers: commonJwtHeader(),
        body: payload,
        method: 'PUT',
        types: [
          API_PROFILE_PUT_REQUEST,
          API_PROFILE_PUT_SUCCESS,
          API_PROFILE_PUT_FAILURE,
        ],
      },
    };
  },
  patchUser: (userId, payload, token) => {
    return {
      [CALL_API]: {
        endpoint: ENDPOINT_USER + encodeURIComponent(userId),
        headers: commonJwtHeader(),
        body: payload,
        method: 'PATCH',
        types: [
          API_PROFILE_PATCH_REQUEST,
          API_PROFILE_PATCH_SUCCESS,
          API_PROFILE_PATCH_FAILURE,
        ],
      },
    };
  },
};
